export default __webpack_public_path__ + "static/rush-13-4c9ff3b5db62ea6b8b67c807dea6df47.png";